import React from 'react';

interface ComplaintData {
  uuid: string;
  accountUuid: string;
  complaintId: string;
  complaintType: string;
  message: string;
  contact_info: string | null;
  createdAt: string;
  subComplaintType: string;
}

interface IProps {
  info: ComplaintData;
  selectedComplaintsInfo: any;
  setSelectedComplaintsInfo: any;
}

const ComplaintCard = (props: IProps) => {
  const { info, selectedComplaintsInfo, setSelectedComplaintsInfo } = props;

  function getRelativeTime(dateString: string): string {
    const date = new Date(dateString);
    const now = new Date();
    const diffInSeconds = Math.floor((now.getTime() - date.getTime()) / 1000);

    const timeUnits: { unit: Intl.RelativeTimeFormatUnit; seconds: number }[] = [
      { unit: 'year', seconds: 60 * 60 * 24 * 365 },
      { unit: 'month', seconds: 60 * 60 * 24 * 30 },
      { unit: 'day', seconds: 60 * 60 * 24 },
      { unit: 'hour', seconds: 60 * 60 },
      { unit: 'minute', seconds: 60 },
      { unit: 'second', seconds: 1 }
    ];

    for (const { unit, seconds } of timeUnits) {
      const interval = Math.floor(diffInSeconds / seconds);
      if (interval >= 1) {
        return `${interval} ${unit}${interval > 1 ? 's' : ''} ago`;
      }
    }

    return 'just now';
  }

  return (
    <div
      key={info.uuid}
      className={`rounded-lg pt-3.5 pl-3.5 pr-2 pb-1.5 cursor-pointer hover:shadow-[0_0_10px_0px_#006BEA] transition-shadow duration-300 
        ${selectedComplaintsInfo.uuid === info.uuid ? 'border border-[#006BEA] bg-[#006BEA]' : 'bg-[#343434]'}`}
      onClick={() => setSelectedComplaintsInfo(info)}
    >
      <div className="flex justify-between items-center">
        <div className="flex gap-x-5 items-center">
          <label className="text-sm text-white font-bold cursor-pointer">Complaint ID</label>
          <label className="text-sm text-white font-regular cursor-pointer">
            {info.complaintId}
          </label>
        </div>
      </div>
      <div className="flex gap-x-12">
        <label className="text-sm text-white font-bold cursor-pointer ">Message</label>
        <label className="text-sm text-white font-regular cursor-pointer max-w-40 md:max-w-60 lg:max-w-72 overflow-hidden text-ellipsis whitespace-nowrap">
          {info.message}
        </label>
      </div>

      <div className="flex justify-end mt-1">
        <label className="text-xs font-bold text-[#D7D7D7] text-right cursor-pointer">
          {getRelativeTime(info.createdAt)}
        </label>
      </div>
    </div>
  );
};

export default ComplaintCard;
